import { CoreStateModel } from './core.model';

export class SetCoreData {
  static readonly type = '[Core] Core data';
  constructor(readonly payload: CoreStateModel) {}
}


export class GetAppConnectedSessions {
	static readonly type = '[WebSocketSession] Get App Connected Sessions';
}

export class HandleServerMessageWebSocketCreated {
	static readonly type = '[WebSocketSession] Document created';
	constructor(public payload: any) { }
}

export class HandleServerMessageWebsocketDeleted {
	static readonly type = '[WebSocketSession] Document deleted';
	constructor(public payload: string) { }
}